import utils, { replaceEpgNames } from 'Utils/epgUtils';
import { logEvent } from 'AppManager/index';
import { Device } from 'DeviceUtils';
import PropTypes from 'prop-types';
import { EPG_LIST_TYPES } from '../../../options';

export const defaultProps = {
    favoriteChannels: [],
    recordings: [],
    updateRecordings: () => {},
    epgSelectedListMode: utils.DEFAULT_LIST_MODE
};

export const propTypes = {
    navigation: PropTypes.shape({}).isRequired,
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    mCoreConfig: PropTypes.shape({}).isRequired,
    setProtectedContent: PropTypes.func.isRequired,
    onSelectProgram: PropTypes.func.isRequired,
    appManager: PropTypes.shape({}).isRequired,
    userData: PropTypes.shape({}).isRequired,
    setModalContent: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    parentalLockConfig: PropTypes.shape({}).isRequired,
    setFavoriteChannels: PropTypes.func.isRequired,
    favoriteChannels: PropTypes.arrayOf(PropTypes.shape({})),
    recordings: PropTypes.arrayOf(PropTypes.shape({})),
    updateRecordings: PropTypes.func,
    epgSelectedListMode: PropTypes.string,
    setEpgSelectedListMode: PropTypes.func.isRequired
};

export const onListModeSelected = async (context, listMode) => {
    const { epgFetchState } = context.state;
    const { setEpgSelectedListMode, setEpgFilteredChannels, setEpgFilters } = context.props;

    if (epgFetchState === utils.EPG_FETCH_STATE.LOADING) return;
    context.offset = 0;
    context.totalItemsCount = 0;
    context.setState({
        listMode,
        epgFetchState: utils.EPG_FETCH_STATE.DONE,
        categories: await context.getDefaultCategories(),
        filteredChannels: [],
        epgItems: [],
        isFetchingPortraitChannels: false,
        requiredPortraitChannelsCount: 0
    });
    context.filterIsUsed = listMode !== utils.DEFAULT_LIST_MODE;
    setEpgFilteredChannels([]);
    setEpgFilters([]);
    setEpgSelectedListMode(listMode);
};

export const onCheckFilter = (context, index) => {
    const { setEpgFilteredChannels, setEpgCategories, epgFilters, setEpgFilters } = context.props;
    const { categories, filteredChannels: oldFilteredChannels } = context.state;
    const selectedCategory = categories[index];
    if (!selectedCategory) return;
    selectedCategory.selected = !selectedCategory.selected;
    const filteredCategories = context.filterCategoriesByListMode([selectedCategory]);
    const selectedCategoryChannels = filteredCategories[0].channels.map((ch) => ch.channelId);
    let filteredChannels;
    let filters = [...epgFilters];

    context.offset = 0;

    if (selectedCategory.selected) {
        filteredChannels = [...new Set([...oldFilteredChannels, ...selectedCategoryChannels])];
        filters.push(selectedCategory);
    } else {
        filteredChannels = oldFilteredChannels.filter(
            (chId) => !selectedCategoryChannels.includes(chId)
        );
        filters = filters.filter((filter) => filter.id !== selectedCategory.id);
    }

    const updatedCategories = categories.map((category) => {
        const matchedCat = filteredCategories.find(
            (filteredCategory) => filteredCategory.id === category.id
        );
        if (matchedCat) {
            return matchedCat;
        }

        return category;
    });

    setEpgFilteredChannels(filteredChannels);
    setEpgFilters(filters);
    setEpgCategories(updatedCategories);
    if (updatedCategories.find((category) => category.selected)) {
        context.filterIsUsed = true;
        context.setState({
            epgFetchState: utils.EPG_FETCH_STATE.DONE,
            categories: updatedCategories,
            filteredChannels
        });
    } else {
        context.onResetFilter(false);
    }
};

// For future reference:
// Listmode = Magio Go / Magio TV etc --- Not really a filter more of a selector
// Filtered channels = actual favorites filter - Kids / Music / Documentary etc..
export const onResetFilter = async (context, resetList = false, cb) => {
    const { setEpgSelectedListMode, setEpgFilteredChannels, setEpgCategories, setEpgFilters } =
        context.props;
    context.filterIsUsed = false;
    context.offset = 0;
    const newState = {
        epgFetchState: utils.EPG_FETCH_STATE.DONE,
        epgItems: [],
        categories: await context.getDefaultCategories(),

        filteredChannels: []
    };

    if (resetList) newState.listMode = utils.DEFAULT_LIST_MODE;

    setEpgFilteredChannels([]);
    setEpgFilters([]);
    setEpgSelectedListMode(newState.listMode);
    setEpgCategories([]);
    context.setState(newState, () => {
        cb?.();
    });
};

export const initChannelsBrief = async (context) => {
    const { appManager, userData, setFavoriteChannels } = context.props;
    let allChannels = [];
    let liveChannels = [];
    try {
        const allResult = await appManager.getApi().fetchChannelsBrief({
            list: EPG_LIST_TYPES.ALL
        });
        allChannels = allResult.items;

        const liveResult = await appManager.getApi().fetchChannelsBrief({
            list: EPG_LIST_TYPES.LIVE
        });
        liveChannels = liveResult.items;
        context.totalItemsCount = liveChannels.length;
        if (userData) await setFavoriteChannels();
    } catch (error) {
        // TODO: how to handle not channels brief?
        console.log(error);
    }

    // context.setState({ allChannels, liveChannels });
    return { allChannels, liveChannels };
};

// Max offset must be lesser than totalItemsCount
const getOffset = (offset, totalItemsCount) =>
    offset > totalItemsCount ? totalItemsCount - 1 : offset;

// TODO: refactor
// eslint-disable-next-line max-statements
export const fetchEpgFromOffset = async (
    context,
    offset,
    dateFrom = null,
    limit = utils.DEFAULT_EPG_LIMIT,
    reset = false,
    forceFetch = false,
    fromSearch = false,
    extend = false
) => {
    const { appManager, setError, epgFilteredChannels, epgFilters } = context.props;

    const { epgFetchState, listMode, filteredChannels } = context.state;

    const { LOADING, DONE, ERROR, END_REACHED } = utils.EPG_FETCH_STATE;
    if (
        context.filterIsUsed !== Boolean(epgFilters.length) &&
        listMode !== EPG_LIST_TYPES.FAVORITES
    )
        return;
    if ((epgFetchState === END_REACHED || epgFetchState === LOADING) && !forceFetch) return;

    if (epgFetchState === ERROR && !forceFetch) {
        context.setState({ epgFetchState: END_REACHED });
        return;
    }

    if (reset) {
        if (Device.isWeb) {
            context.setState({ epgItems: [] });
        } else if (global.epgAndoidNativeInstance) {
            global.epgAndoidNativeInstance.resetData();
        }
    }

    context.setState({ epgFetchState: LOADING });
    const interval = utils.getDateInterval(dateFrom);
    const calculatedOffset = getOffset(offset, context.totalItemsCount);
    const params = {
        // eslint-disable-next-line no-nested-ternary
        list: fromSearch
            ? EPG_LIST_TYPES.LIVE
            : listMode === EPG_LIST_TYPES.FAVORITES
              ? EPG_LIST_TYPES.ALL
              : listMode || utils.DEFAULT_LIST_MODE,
        limit,
        offset: calculatedOffset,
        ...interval
    };

    let filterChannelIdsParam;

    if (!filteredChannels.length) {
        filterChannelIdsParam = epgFilteredChannels;
    } else {
        filterChannelIdsParam = filteredChannels;
    }

    if (listMode === EPG_LIST_TYPES.FAVORITES) {
        try {
            filterChannelIdsParam = await context.fetchUserFavorites(filterChannelIdsParam);
        } catch (error) {
            console.log(error);
            context.setState({ epgFetchState: DONE });
            setError({ error, screenId: 'epg', context: 'epg' });
            return;
        }
    }
    if (
        fromSearch &&
        filterChannelIdsParam.includes(fromSearch) &&
        filterChannelIdsParam.indexOf(fromSearch) < utils.DEFAULT_EPG_LIMIT
    ) {
        context.setState({ epgFetchState: DONE });
        return;
    }

    if (filterChannelIdsParam.length > 0 && !fromSearch) {
        delete params.list;
        params.channelIds = filterChannelIdsParam.join(',');
    }
    try {
        const { items: newEpgItems, totalCount } = await appManager.getApi().fetchEpg(params);
        const {
            selectedDate,
            epgItems,
            isFetchingPortraitChannels,
            requiredPortraitChannelsCount
        } = context.state;
        if (dateFrom === selectedDate) {
            // Extend names only once here
            replaceEpgNames(newEpgItems);
            context.totalItemsCount = totalCount;
            context.offset += limit;
            let nextEpgFetchState = newEpgItems.length ? DONE : END_REACHED;
            if (totalCount <= context.offset) nextEpgFetchState = END_REACHED;

            // If user filtering do not extend existing items
            // Only for the first fetch, then extend
            // I.E. > offset favorites will be loaded n times
            const mergedEpgItems =
                context.filterIsUsed && offset === 0 && !extend
                    ? newEpgItems
                    : [...epgItems, ...newEpgItems];
            const newIsFetchingPortraitChannels = !(
                requiredPortraitChannelsCount <=
                mergedEpgItems.length + epgItems.length
            );
            context.setState(
                {
                    epgItems: mergedEpgItems,
                    epgFetchState: nextEpgFetchState,
                    ...(isFetchingPortraitChannels && {
                        isFetchingPortraitChannels: newIsFetchingPortraitChannels
                    })
                },
                () => {
                    context.isFetchingRest = false;
                }
            );
        }
    } catch (error) {
        console.log(error);
        context.setState({ epgFetchState: ERROR });
        setError({ error, screenId: 'epg', context: 'epg' });
    }
};

export const fetchUserFavorites = async (context, filteredChannels) => {
    const { appManager, userData } = context.props;
    let filterChannelIdsParam;
    if (!userData) {
        return [];
    }
    const { data } = await appManager.getApi().fetchCustomChannelMapList(userData.deviceId);
    const { order } = data[0];
    // do an intersection of favorite and filter if there is any filter, else just favorite ones
    if (filteredChannels.length) {
        filterChannelIdsParam = filteredChannels.filter((chId) => order.includes(chId));
    } else {
        filterChannelIdsParam = [...order];
    }

    return filterChannelIdsParam;
};

export const logDetailNavigation = (cell) =>
    logEvent({
        type: 'navigation',
        subtype: 'epgFullDetail',
        content1: cell?.getId(),
        content2: cell?.modelType
    });

export const popupDetails = (context, cell) => {
    // Can't do destruct because we will loose context. primarily problem on web
    // eslint-disable-next-line react/destructuring-assignment
    const { setProtectedContent, setModalContent } = context.props;
    const { allChannels } = context.state;
    const currentBriefChannel = allChannels.find(
        (channel) => channel.channelId === cell.data.channelId
    );

    if (cell.data.isLocked || cell.data.isAgeBlocked) {
        return setProtectedContent(
            cell,
            () => {
                logDetailNavigation(cell);
                context.setState({ displayDetails: true, selectedCell: cell, currentBriefChannel });
            },
            false,
            (success) => {
                setModalContent(null);
                if (!success) {
                    context.setState({
                        displayDetails: false,
                        selectedCell: null,
                        currentBriefChannel: null
                    });
                }
                if (!Device.isWeb) context.epgRef.removeFocus();
            }
        );
    }

    logDetailNavigation(cell);
    // Can't do destruct because we will loose context. primarily problem on web
    // eslint-disable-next-line react/destructuring-assignment
    context.setState({ displayDetails: true, selectedCell: cell, currentBriefChannel });
    return null;
};

export const getDefaultCategories = async (context) => {
    const { appManager, userData, setCategories } = context.props;
    const api = appManager.getApi();

    try {
        const { categories } = await api.getCategories(
            userData ? userData.lang : utils.DEFAULT_LANGUAGE
        );

        setCategories(categories);
        context.setState({ categories });

        return categories?.map((category) => {
            category.selected = false;
            return category;
        });
    } catch (error) {
        console.log(error);
    }
};

export default {
    onListModeSelected,
    onCheckFilter,
    onResetFilter,
    initChannelsBrief,
    fetchEpgFromOffset,
    fetchUserFavorites,
    logDetailNavigation,
    popupDetails,
    getDefaultCategories,
    defaultProps
};
